import {computed} from 'vue';
import {storeToRefs} from 'pinia';
import {useAuth} from '#imports';
import {useUserInfo} from '~/composables/useUserInfo';
import {useSearchFeaturesStore} from '../stores/search-features.store';

const DEFAULT_CONTACT = 'contact@malt.com';

export function useProfileViews() {
    const authStore = useAuth();
    const searchFeaturesStore = useSearchFeaturesStore();
    const {serviceLevel} = useUserInfo();

    const {currentIdentityIsClient} = storeToRefs(authStore);
    const {profileViews} = storeToRefs(searchFeaturesStore);

    const limitReached = computed(() => profileViews.value && profileViews.value.count >= profileViews.value.limit);

    const profileViewsStatus = computed(() => {
        if (profileViews.value) {
            return {
                count: profileViews.value.count,
                limit: profileViews.value.limit,
            };
        }
        return null;
    });
    const abuseContactEmail = computed(() => profileViews.value?.abuseContactEmail ?? DEFAULT_CONTACT);
    const shouldUpgrade = computed(() => limitReached.value && currentIdentityIsClient.value && serviceLevel.value === 'STARTER');
    const abuseSuspected = computed(() => !shouldUpgrade.value && limitReached.value);

    async function updateProfileViewsStatus() {
        await searchFeaturesStore.fetchFeatures();
    }

    return {
        abuseContactEmail,
        profileViewsStatus,
        shouldUpgrade,
        abuseSuspected,
        updateProfileViewsStatus,
    };
}
